import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { endpoints } from "../../services/apiurl";
import { Card } from "@mui/material";
import PageTitle from "../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { InfinitySpin } from "react-loader-spinner";

function ComingSoonOutlet() {
    let { restro_id } = useParams();
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    useEffect(() => {
        fetchData(1, perPage);
      }, [perPage]);
    
      const columns = [
        {
          name: "NAME",
          selector: (row) => row.name,
        },
       
        {
          name: "STATUS",
          selector: (row) => (row.status == 1 ? "Active" : "Inactive"),
          
        },
        {
          name: "ACTION",
          cell: (row) => (
            <div>
              {" "}
              <Link to={`/dashboard/editcomingoutlet/${row.id}`}>
                {" "}
                <EditIcon />{" "}
              </Link>
              <Link
                className="error"
                style={{ marginTop: "7px", marginLeft: "10px" }}
                onClick={() => {
                  confirmAlert({
                    title: "Confirm",
                    message: "Do you really want to delete?",
                    buttons: [
                      {
                        label: "Yes",
                        onClick: () => removeContactHandler(row.id),
                      },
                      {
                        label: "No",
                        onClick: () => {},
                      },
                    ],
                  });
                }}
              >
                <DeleteIcon />
              </Link>
            </div>
          ),
          selector: (row) => row.id,
          // width: '200px'
        },
      ];

      const removeContactHandler = async (id) => {
        await axios
          .post(endpoints.deleteLotdCSoon, { id })
          .then((response) => {});
        const newContactList = items.filter((contact) => {
          return contact.id !== id;
        });
        setItems(newContactList);
      };
    
      const fetchData = async (page, per_page) => {
    
        await axios
          .post(endpoints.getLotdCSoon, {
            page,
            per_page,
          
          })
          .then(
            (response) => {
              setIsLoaded(true);
              setItems(response.data.data);
              setTotalRows(response.data.total);
            },
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          );
      };
    
      const handlePageChange = (page) => {
        fetchData(page, perPage);
      };
    
      const handlePerRowsChange = async (newPerPage) => {
        setPerPage(newPerPage);
      };

   if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return  <div className="spinner">
    <InfinitySpin
      visible={true}
      width="200"
      color="#fbaa1a"
      ariaLabel="infinity-spin-loading"
    />
  </div>;
  } else {
    return (
      <div className="App">
        <PageTitle
          title="Coming Soon Outlet List"
          linkid={restro_id}
          linkurl="/dashboard/addcomingoutlet"
          linkTitle="Add Outlet"
        />
        <Card className="px-3 py-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
  
}

export default ComingSoonOutlet